import React from 'react';
import Appbar from 'components/appbar/Appbar';
import PaymentMethodAction from './PaymentMethodAction';
import PageHeaderActions from 'components/page-header/PageHeaderActions';
import NewRecordButton from 'components/page-header/NewRecordButton';
import { useFetchPaymentMethods } from './hooks/useFetchPaymentMethods';
import PaymentMethodFilterBox from './PaymentMethodFilterBox';
import Pagination from 'components/pagination/Pagination';
import PaymentMethodListTable from './list/table/PaymentMethodListTable';
import PaymentMethodListModule from './list/module/PaymentMethodListModule';
import { useDisplayMode } from 'hooks/useDisplayMode';
import PaginationProvider from 'hooks/pagination';
import TableLoading from 'components/loading/TableLoading';
import ModuleLoading from 'components/loading/ModuleLoading';
import NoData from 'components/no-data/NoData';

const PaymentMethod: React.FC = () => {
  const {
    paymentMethods,
    loading,
    handleSort,
    filter,
    handleChange,
    setPage,
    setRows,
    handleSearch,
    page,
    rows,
    total,
  } = useFetchPaymentMethods();
  const [displayMode] = useDisplayMode();
  return (
    <>
      <Appbar title="Formas de recebimento" ActionsComponent={<PaymentMethodAction />} />
      <PageHeaderActions
        title="Formas de recebimento"
        description="Gestão de formas de recebimento"
        ActionComponent={<NewRecordButton label="Nova forma de recebimento" to="/payment-methods/new" />}
      />

      <PaymentMethodFilterBox
        filter={filter}
        handleChange={handleChange}
        handleSearch={handleSearch}
        loading={loading}
      />

      <PaginationProvider rowsPerPage={rows}>
        {loading ? (
          displayMode === 'list' ? (
            <TableLoading />
          ) : (
            <ModuleLoading />
          )
        ) : paymentMethods.length === 0 ? (
          <NoData message="Nenhuma forma de recebimento encontrada" />
        ) : (
          <>
            {displayMode === 'list' ? (
              <PaymentMethodListTable paymentMethods={paymentMethods} />
            ) : (
              <PaymentMethodListModule handleSearch={handleSearch} paymentMethods={paymentMethods} />
            )}

            <Pagination
              count={total}
              currentPage={page}
              currentRowsPerPage={rows}
              onChangePage={page => setPage(page)}
              onChangeRowsPerPage={rows => setRows(rows)}
            />
          </>
        )}
      </PaginationProvider>
    </>
  );
};

export default PaymentMethod;
